module.exports = __webpack_public_path__ + "static/media/tti_slogan@2x.c966f265.png";